import { render, staticRenderFns } from "./noticia.vue?vue&type=template&id=a8a08da6&scoped=true"
import script from "./noticia.vue?vue&type=script&lang=js"
export * from "./noticia.vue?vue&type=script&lang=js"
import style0 from "./noticia.vue?vue&type=style&index=0&id=a8a08da6&prod&scoped=true&lang=css"
import style1 from "./noticia.vue?vue&type=style&index=1&id=a8a08da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a08da6",
  null
  
)

export default component.exports